import { useState } from 'react';

import { PlatformSwitcher } from '@/components/PlatformSwitcher';
import { UserPopover, UserPopoverProps } from '@/features/users/components/UserPopover/UserPopover';

import { AppNavbarActionsDrawerNotification } from './components/AppNavbarActionsDrawer';

interface AppNavbarActionsProps {
  userPopoverProps: UserPopoverProps;
  showPlatformsSwitcher: boolean;
  onShowPlatformsSwitcherChange: (show: boolean) => void;
  popoverPosition?: 'top' | 'bottom';
}

export function AppNavbarActions({
  userPopoverProps,
  showPlatformsSwitcher,
  onShowPlatformsSwitcherChange,
  popoverPosition = 'bottom',
}: AppNavbarActionsProps) {
  const [show, setShow] = useState(false);

  const completeUserPopoverProps = {
    ...userPopoverProps,
    popoverPosition,
  };

  return (
    <>
      <PlatformSwitcher
        showPlatformsSwitcher={showPlatformsSwitcher}
        onShowPlatformsSwitcherChange={onShowPlatformsSwitcherChange}
        popoverPosition={popoverPosition}
      />

      <UserPopover {...completeUserPopoverProps} />

      <AppNavbarActionsDrawerNotification
        isOpen={show}
        onSubmit={() => setShow(false)}
        onCancel={() => setShow(false)}
      />
    </>
  );
}
